import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const giveGiftRoute = createRoute({
  path: 'readings/gift',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/gifts/give-page'), 'GiveGiftPage'),
  errorComponent: RouteError,
})

export const myGiftsRoute = createRoute({
  path: 'readings/gifts',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/gifts/list-page'), 'MyGiftsPage'),
  errorComponent: RouteError,
})

export const claimGiftRoute = createRoute({
  path: 'gift/$code',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/gifts/claim-page'), 'ClaimGiftPage'),
  errorComponent: RouteError,
})
